import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios"
import { useUser } from "../UserContext";
import { useHistory } from "react-router-dom";
const ReportWeeklyMarketContext = createContext();

export const ReportWeeklyMarketProvider = ({ children }) => {
    const history = useHistory();
    const { marketPlace, jogo } = useUser()

    const [reportWeeklyMarket, setReportWeeklyMarket] = useState({
        sales: [],
        purchasesInProgress: [],
        purchasesDone: []
    })
    const [loading, setLoading] = useState(false)

    const fetchReportWeeklyMarket = useCallback(async () => {
        if (!marketPlace?.supermercado || !jogo?.jogo) return
        try {
            setLoading(true)
            const { data: allRounds } = await axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/rodada/listarRodadas/${jogo?.jogo}`)

            const promisesSales = allRounds.map(round => {
                return axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/vendasupermercado/listar/${marketPlace?.supermercado}/${round?.rodada}`)
            })

            const salesData = await Promise.all(promisesSales)
            const sales = salesData.map(item => item.data).filter(item => item.length > 0)

            let filteredSalesData = []

            for (let i = 0; i < sales.length; i++) {
                let newSalesData = sales[i].reduce((acc, item) => {
                    if (acc?.length === 0) {
                        acc.push({
                            ...item,
                            itemVenda: [{
                                produto: {
                                    ...item.itens[0].produto
                                },
                                quantidadeTotal: item.itens[0].quantidade,
                                valorTotal: item.itens[0].total
                            }]
                        })
                        return acc
                    }

                    const itemIndex = acc?.findIndex(acumulatorItem => acumulatorItem?.itens[0]?.produto?.produto === item?.itens[0]?.produto?.produto)
                    if (itemIndex >= 0) {
                        acc[itemIndex].itemVenda[0].quantidadeTotal = acc[itemIndex].itemVenda[0].quantidadeTotal += item.itens[0].quantidade
                        acc[itemIndex].itemVenda[0].valorTotal = acc[itemIndex].itemVenda[0].valorTotal += item.itens[0].total
                        return acc
                    }

                    acc.push({
                        ...item,
                        itemVenda: [{
                            ...item.itens[0],
                            quantidadeTotal: item.itens[0].quantidade,
                            valorTotal: item.itens[0].total
                        }]
                    })
                    return acc

                }, [])

                filteredSalesData.push(newSalesData)
            }

            /* Fluxo compras*/
            const promisesPurchaseInProgess = allRounds.map(round => {
                return axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/venda/listarSupermercado/${marketPlace?.supermercado}/${round.rodada}/A`)
            })

            const purchaseInProgessData = await Promise.all(promisesPurchaseInProgess)
            const purchaseInProgess = purchaseInProgessData.map(item => item.data).filter(item => item.length > 0)

            let filteredPurchaseInProgessData = []

            for (let i = 0; i < purchaseInProgess.length; i++) {
                let newPurchaseInProgessData = purchaseInProgess[i].reduce((acc, item) => {
                    if (acc?.length === 0) {
                        acc.push({
                            ...item,
                            itemCompra: [{
                                produto: {
                                    ...item.itens[0].produto
                                },
                                quantidadeTotal: item.itens[0].quantidade,
                                valorTotal: item.itens[0].total
                            }]
                        })
                        return acc
                    }

                    const itemIndex = acc?.findIndex(acumulatorItem => acumulatorItem?.itens[0]?.produto?.produto === item?.itens[0]?.produto?.produto)
                    if (itemIndex >= 0) {
                        acc[itemIndex].itemVenda[0].quantidadeTotal = acc[itemIndex].itemVenda[0].quantidadeTotal += item.itens[0].quantidade
                        acc[itemIndex].itemVenda[0].valorTotal = acc[itemIndex].itemVenda[0].valorTotal += item.itens[0].total
                        return acc
                    }

                    acc.push({
                        ...item,
                        itemCompra: [{
                            ...item.itens[0],
                            quantidadeTotal: item.itens[0].quantidade,
                            valorTotal: item.itens[0].total
                        }]
                    })
                    return acc

                }, [])

                filteredPurchaseInProgessData.push(newPurchaseInProgessData)
            }

            const promisesPurchaseDone = allRounds.map(round => {
                return axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/venda/listarSupermercado/${marketPlace?.supermercado}/${round.rodada}/E`)
            })

            const purchaseDoneData = await Promise.all(promisesPurchaseDone)
            const purchaseDone = purchaseDoneData.map(item => item.data).filter(item => item.length > 0)

            let filteredPurchaseDoneData = []

            for (let i = 0; i < purchaseDone.length; i++) {
                let newPurchaseDoneData = purchaseDone[i].reduce((acc, item) => {
                    if (acc?.length === 0) {
                        acc.push({
                            ...item,
                            itemCompra: [{
                                produto: {
                                    ...item.itens[0].produto
                                },
                                quantidadeTotal: item.itens[0].quantidade,
                                valorTotal: item.itens[0].total
                            }]
                        })
                        return acc
                    }

                    const itemIndex = acc?.findIndex(acumulatorItem => acumulatorItem?.itens[0]?.produto?.produto === item?.itens[0]?.produto?.produto)
                    if (itemIndex >= 0) {
                        acc[itemIndex].itemVenda[0].quantidadeTotal = acc[itemIndex].itemVenda[0].quantidadeTotal += item.itens[0].quantidade
                        acc[itemIndex].itemVenda[0].valorTotal = acc[itemIndex].itemVenda[0].valorTotal += item.itens[0].total
                        return acc
                    }

                    acc.push({
                        ...item,
                        itemCompra: [{
                            ...item.itens[0],
                            quantidadeTotal: item.itens[0].quantidade,
                            valorTotal: item.itens[0].total
                        }]
                    })
                    return acc

                }, [])

                filteredPurchaseDoneData.push(newPurchaseDoneData)
            }

            console.log(filteredPurchaseDoneData);
            /* Fim fluxo compras */
            setReportWeeklyMarket({
                sales: filteredSalesData,
                purchasesInProgress: filteredPurchaseInProgessData ?? [],
                purchasesDone: filteredPurchaseDoneData ?? []
            })
            setLoading(false)


        } catch (e) {
            console.log(e)
            setLoading(false)
        }

    }, [marketPlace, jogo])


    return (
        <ReportWeeklyMarketContext.Provider
            value={{
                reportWeeklyMarket,
                loading,
                fetchReportWeeklyMarket,
                setReportWeeklyMarket
            }}
        >
            {children}
        </ReportWeeklyMarketContext.Provider>
    );
};

export const useReportWeeklyMarket = () => useContext(ReportWeeklyMarketContext);
